import React from 'react'
import {
  ClearTheChartsProvider,
} from './ClearTheChartsContext'
import { ClearTheCharts } from './ClearTheCharts'

const ClearTheChartsContainer = () => {
  return (
    <div>
      <ClearTheChartsProvider>
        <ClearTheCharts />
      </ClearTheChartsProvider>
    </div>
  )
}

export default ClearTheChartsContainer
